<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 justify-center>
        <v-card
          v-for="product in products"
          class="my-4"
          style="border-radius: 12px;"
          v-bind:key="product.id"
        >
          <v-card-title class="headline font-weight-bold">
            {{ product.title }}
          </v-card-title>
          <v-card-text>
            {{ product.description }}
          </v-card-text>

          <v-card-actions>
            <v-flex>
              <v-btn
                class="primary"
                rounded
                block
                :loading="loading === product.id"
                :disabled="loading !== ''"
                v-on:click="generate_token(product.id)"
                >Go to {{ product.title }}</v-btn
              >
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex></v-layout
    >
  </v-container>
</template>

<script>
export default {
  /* global firebase */
  name: "Products",
  data() {
    return {
      product_listener: null,
      products: [],
      show_alert: false,
      alert_type: "success",
      alert_text: "",
      loading: ""
    };
  },
  methods: {
    go_to_product(id) {
      let product = null;
      this.products.forEach(p => {
        if (p.id === id) product = p;
      });
      if (product === null) return;
      window.location.href = product.base_url;
    },

    generate_token(id) {
      let product = null;
      this.products.forEach(p => {
        if (p.id === id) {
          product = p;
          product.loading = true;
        }
      });
      if (product === null) return;
      this.loading = id;

      this.show_alert = false;
      this.$store
        .dispatch("user/generate_sso_url", product.id)
        .then(result => {
          this.loading = "";
          window.location.href = result;
        })
        .catch(() => {
          this.loading = "";
          this.alert_type = "error";
          this.alert_text = "Could not Authenticate";
          this.show_alert = true;
        });
    }
  },
  created() {
    this.product_listener = firebase
      .firestore()
      .collection("users")
      .doc(this.$store.getters["user/auth_profile"].uid)
      .collection("enabled_products")
      .onSnapshot(querySnapshot => {
        this.products = [];
        querySnapshot.docs.forEach(doc => {
          this.products.push(doc.data());
        });
      });
  },
  beforeDestroy() {
    try {
      this.product_listener();
      // eslint-disable-next-line no-empty
    } catch (err) {}
    this.product_listener = null;
  }
};
</script>

<style scoped></style>
